<template>
    <f7-page
        name="Journey"
        no-swipeback
        no-navbar
    >

        <f7-block>
            <h2>
                {{ topic.name }}
            </h2>

            <div
                :key="topic.id"
                class="description"
                v-html="topic.description"
            />

        </f7-block>

        <div
            v-for="(course, n) in currentCourses"
            :key="`course-${topic.id}-${n}`"
            class="selectable"
            style=""
        >
            <h1 style="padding-left: 16px;clear: both; padding-top: 30px">Section {{ n+1 }}: {{ course.name }} (courseId: {{ course.id }})</h1>
            <div
                v-for="(unit, m) in course.units"
                :key="`unit-${unit.id}-${m}`"
                style="clear: both"
            >
                <f7-block style="clear: both; padding-top: 0px">
                    <h2 style="text-align: left">Unit {{ m+1 }}: {{ unit.name }} (<a
                            :href="`/admin/units/${unit.id}`"
                            class="external"
                            target="_blank"
                        >unitId: {{ unit.id }}</a>)</h2>
                    <div
                        v-for="(slide, m) in unit.slides"
                        :key="`slide-${slide.id}-${m}`"
                        class="slideHolderParent"
                    >
                        <a
                            :href="`/admin/slides/${slide.id}`"
                            class="external"
                            target="_blank"
                        >slideId:{{ slide.id }}</a><br>
                        <div class="slideHolder">
                            <slide
                                :slide="slide"
                                :index="m"
                                :total="unit.slides.length"
                                :unit="unit"
                            />
                            <div
                                class="slideReferences"
                                v-html="slide.data.references"
                            />
                        </div>
                    </div>
                </f7-block>
            </div>
        </div>

    </f7-page>
</template>

<script>
import Slide from '../components/slide.vue';

export default {
    store: ['api', 'user'],
    components: {
        slide: Slide
    },
    data() {
        return {
            topic: {
                id: 0,
                name: ''
            },
            topics: [],
            topicsIndex: [],
            courses: [],
            coursesIndex: [],
            currentCourses: [],
            currentId: 0,
            myTopicsBuilt: false
        };
    },
    computed: {
        isPgap: function() {
            return pgap;
        }
    },
    created: function() {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        setTimeout(() => {
            this.getTopics();
            this.getCourses();
        }, 200);
    },
    mounted: function() {
        this.topic.id = this.currentId;
        this.myTopicsBuilt = false;
        // if (this.courses.length && this.topics.length) this.buildByTopicList();

        // f7.statusbar.setBackgroundColor('#65749B');
        // f7.statusbar.setTextColor('white');
    },
    beforeDestroy: function() {},
    methods: {
        closePopup: function() {
            f7.popup.get('#popup').close();
            f7.views['popup'].router.navigate('/blank');
            f7.statusbar.setTextColor('black');
        },
        buildByTopicList: function() {
            // if (this.myTopicsBuilt) return;
            if (!this.courses.length || !this.topics.length) return;
            this.myTopicsBuilt = true;
            this.fullDataIndex = JSON.parse(JSON.stringify(this.topicsIndex));
            this.fullDataIndex[0] = {
                courses: [],
                name: 'Unassigned'
            };
            for (let i = 0; i < this.topics.length; i++) {
                const topic = this.topics[i];
                if (!this.fullDataIndex[topic.id]) this.fullDataIndex[topic.id] = {};
                this.fullDataIndex[topic.id].courses = [];
            }
            for (let i = 0; i < this.courses.length; i++) {
                const course = this.courses[i];
                if (course.topicId === this.currentId) {
                    this.getUnits(course, course.id);
                }
                if (this.fullDataIndex[course.topicId] && this.fullDataIndex[course.topicId].courses)
                    this.fullDataIndex[course.topicId].courses.push(course);
                else console.log(course.topicId);
            }
            setTimeout(() => {
                // For animation
                this.topic = this.topicsIndex[this.currentId];
                this.currentCourses = this.fullDataIndex[this.currentId].courses;
            }, 400);
        },
        getUnits: function(course, courseId) {
            this.$http.get(`${this.api}/courses/${courseId}/units?withSlides=1`).then(
                response => {
                    Vue.set(course, 'units', response.body || []);
                    console.log(course.units);
                    for (let i = 0; i < course.units.length; i++) {
                        const unit = course.units[i];
                        // if (typeof course.totals[unit.type] !== 'undefined') {
                        //     course.totals[unit.type]++;
                        // }
                    }
                    return course;
                },
                response => {
                    console.error(response.body.message || 'Unknown error 1106');
                }
            );
        },
        getCourses: function() {
            f7.preloader.show();
            this.$http.get(`${this.api}/courses?admin=1`).then(
                response => {
                    this.courses = response.body || {};
                    for (let i = 0; i < this.courses.length; i++) {
                        this.coursesIndex[this.courses[i].id] = this.courses[i];
                    }
                    if (this.courses.length && this.topics.length) this.buildByTopicList();
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        },
        getTopics: function() {
            this.$http.get(`${this.api}/topics?admin=1`).then(
                response => {
                    this.topics = response.body || {};
                    for (let i = 0; i < this.topics.length; i++) {
                        if (this.topics[i].id === this.currentId) this.topic = this.topics[i];
                        this.topicsIndex[this.topics[i].id] = this.topics[i];
                    }
                    if (this.courses.length && this.topics.length) this.buildByTopicList();
                },
                response => {
                    console.error(response.body || 'Unknown error 193');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.slideHolderParent {
    border: 1px solid gray;
    max-width: 380px;
    float: left;
}
</style>
